// Build array of viewed items and storing in local storage
const buildViewedItems = () => {
    if (typeof window.ShopifyAnalytics === 'undefined' || !window.ShopifyAnalytics.meta || !window.ShopifyAnalytics.meta.product) return

    if (window.ShopifyAnalytics.meta.page.pageType !== 'product') return

    const currentProductId = String(window.ShopifyAnalytics.meta.product.id)
    const storageKey = 'nyr_viewed_products'
    const maxProducts = 10

    const stored = localStorage.getItem(storageKey)

    let viewedProducts = stored ? JSON.parse(stored) : []

    if (!viewedProducts.includes(currentProductId)) {
        viewedProducts.push(currentProductId)

        if (viewedProducts.length > maxProducts) viewedProducts = viewedProducts.slice(-maxProducts)
    }

    localStorage.setItem(storageKey, JSON.stringify(viewedProducts))
}
buildViewedItems()

// Open Klaviyo signup popup on button click
const openKlaviyoPopup = () => {
    document.querySelectorAll('a[href="/?newsletterpopup"]').forEach(trigger => {
        trigger.addEventListener('click', e => {
            e.preventDefault()

            window._klOnsite = window._klOnsite || []
            window._klOnsite.push(['openForm', 'Xf2Pry'])
        })
    })
}
openKlaviyoPopup()